import React from 'react';
import { I18n } from 'react-redux-i18n';

import { I18N_BASE } from '../../constants';
import { EventSnapshot, firstElementByRole, ModerationEvent } from '../../models';
import SnapshotField from '../../components/SnapshotField/SnapshotField';
import { resolveImagePath } from './imageUrls';
import styles from './review.module.css';

export interface ImageBlobSnapshotCardProps {
  event: ModerationEvent;
  snapshot: EventSnapshot;
  testId?: string;
}

export function ImageBlobSnapshotCard({
  event,
  snapshot,
  testId,
}: ImageBlobSnapshotCardProps): React.ReactElement {
  const blobImage = firstElementByRole(snapshot.elements, 'blobImage');

  return (
    <section className={styles.snapshotCard} data-testid={testId}>
      <SnapshotField
        label={I18n.t(`${I18N_BASE}.detail.snapshot.role.blobImage`)}
        flagged={Boolean(blobImage?.flagged)}
        testId="snapshot-blobImage"
      >
        {blobImage?.value ? (
          <img
            className={`${styles.imageTile} ${blobImage.flagged ? styles.imageTileFlagged : ''}`}
            src={resolveImagePath(blobImage.value)}
            alt=""
          />
        ) : (
          <span>—</span>
        )}
      </SnapshotField>
      <SnapshotField
        label={I18n.t(`${I18N_BASE}.detail.snapshot.blobMediaKind`)}
        flagged={false}
        testId="snapshot-blobMediaKind"
      >
        {event.blobMediaKind ?? '—'}
      </SnapshotField>
    </section>
  );
}

export default ImageBlobSnapshotCard;
